import baseByData from '@brixel-io/brixel-components/dist/configuration/Settings';
import { getCookie } from '@brixel-io/brixel-components/dist/utils/helper';
import get from 'lodash/get';
import queryString from 'query-string';
import { ERROR_MESSAGE, SET_FORM_ERROR, SET_NOTIFICATION, SET_SCREEN_NOTIFICATION, SPINNER_OFF, SPINNER_ON, } from '../actions/types/CommonTypes';
import { CHECK_TOKEN, CREATE_USER, DO_LOGOUT, GET_TOKEN, GET_USER, RECOVER_PASSWORD, SET_USER, UPDATE_USER, } from '../actions/types/UserTypes';
import api from '../controllers/api/config';
import { setCookie, unsetCookie } from '../utils/helpers';
import { getTokenControllerGetToken } from '../generated/brixel-api-v3';
import { disableSpinner, enableSpinner } from './CommonMiddleware';
const checkUser = (store) => (next) => (action) => {
    switch (action.type) {
        case CHECK_TOKEN: {
            next(action);
            store.dispatch({ type: SPINNER_ON });
            if (!getCookie('brixelToken') &&
                !get(window, 'location.href', '').includes('logout') &&
                !get(window, 'location.href', '').includes('recover') &&
                !get(window, 'location.href', '').toLowerCase().includes('redeeminvite') &&
                !get(window, 'location.href', '').includes('login')) {
                unsetCookie('brixelToken');
                if (!window.location.href.includes('signup') && !window.location.href.includes('login'))
                    window.location.assign('/login');
                store.dispatch({ type: SPINNER_OFF });
                return false;
            }
            api.user.validateToken(action.payload)
                .then((response) => {
                if (get(response, 'data.valid', false) === true) {
                    api.user.getUserByToken(action.payload)
                        .then((res) => {
                        let userData = res.data;
                        if (res.data.id) {
                            api.user.getUser(res.data.id)
                                .then((res2) => {
                                userData = { ...res.data, ...res2.data };
                                store.dispatch({ type: SET_USER, payload: userData });
                                store.dispatch({ type: SPINNER_OFF });
                            });
                        }
                    });
                }
                store.dispatch({ type: SPINNER_OFF });
            })
                .catch(() => {
                if (get(window, 'location.href', '').includes('localhost')) {
                    store.dispatch({ type: SET_USER, payload: {} });
                }
                if (!get(window, 'location.href', '').includes('logout') && !get(window, 'location.href', '').includes('login')) {
                    // unsetCookie('brixelToken');
                    // window.location.assign('/login');
                    store.dispatch({ type: SPINNER_OFF });
                    return false;
                }
                store.dispatch({ type: SPINNER_OFF });
            });
            break;
        }
        case DO_LOGOUT: {
            next(action);
            unsetCookie('brixelToken');
            const urlParams = queryString.parse(window.location.href.split('?')[1]);
            if (typeof window !== 'undefined') {
                if ((window.location.href.includes('hub') || window.location.href.includes('admin') || window.location.href.includes('localhost')) && urlParams.url) {
                    window.location.href = `${baseByData.loginUrl}?url=${urlParams.url}`;
                }
                else {
                    window.location.href = '/login';
                }
            }
            break;
        }
        case GET_TOKEN: {
            next(action);
            store.dispatch({ type: SPINNER_ON });
            const { username, password } = action.payload;
            getTokenControllerGetToken({
                headers: {
                    authorization: 'Basic ' + btoa(`${username}:${password}`),
                },
                baseUrl: baseByData.apiPath,
                query: {
                    rememberMe: true,
                },
            })
                .then((response) => {
                localStorage.removeItem('brixelLoginChannel');
                setCookie('brixelToken', response.data.token);
                const notificationProps = {
                    label: 'You are logged in',
                    type: 'done',
                    state: true,
                };
                store.dispatch({ type: SET_SCREEN_NOTIFICATION, payload: notificationProps });
                store.dispatch({ type: ERROR_MESSAGE, payload: {} });
                return response;
            })
                .then((tokenResponse) => {
                let defaultRedirect = baseByData.hubUrl;
                api.user.getUserByToken(tokenResponse.data.token)
                    .then((userResponse) => {
                    if (userResponse.data.seller === false) {
                        defaultRedirect = `${baseByData.hubUrl}buy`;
                    }
                    else {
                        defaultRedirect = `${baseByData.hubUrl}sell`;
                    }
                    const redirectURl = window.localStorage.getItem('brixelRedirectUrl') || defaultRedirect;
                    if (typeof window !== 'undefined')
                        window.location.href = redirectURl;
                })
                    .catch(() => {
                    if (typeof window !== 'undefined' && window.location.href)
                        window.location.href = defaultRedirect;
                });
            })
                .catch(() => {
                const alertProps = {
                    label: 'Email and password combination are invalid.',
                    type: 'alert',
                    state: true,
                };
                store.dispatch({ type: SET_SCREEN_NOTIFICATION, payload: alertProps });
            })
                .finally(() => store.dispatch({ type: SPINNER_OFF }));
            break;
        }
        case RECOVER_PASSWORD: {
            next(action);
            store.dispatch({ type: SPINNER_ON });
            store.dispatch({ type: SET_NOTIFICATION, payload: [] });
            api.user.recoverPassword(action.payload)
                .then(() => {
                const alertProps = {
                    color: '',
                    label: 'If you have an account with us, check your mailbox for the new password!',
                    type: 'done',
                    state: true,
                };
                store.dispatch({ type: SET_SCREEN_NOTIFICATION, payload: alertProps });
            })
                .catch((error) => {
                if (error.meta?.status === 403) {
                    const alertProps = {
                        color: 'txtRed400',
                        label: 'There is no account registered with this email',
                        type: 'alert',
                        state: true,
                    };
                    store.dispatch({ type: SET_SCREEN_NOTIFICATION, payload: alertProps });
                }
                else {
                    // eslint-disable-next-line no-console
                    console.log(error);
                    const alertProps = {
                        color: 'txtRed400',
                        label: 'Unknown error',
                        type: 'alert',
                        state: true,
                    };
                    store.dispatch({ type: SET_SCREEN_NOTIFICATION, payload: alertProps });
                }
            })
                .finally(() => store.dispatch({ type: SPINNER_OFF }));
            break;
        }
        case CREATE_USER: {
            next(action);
            store.dispatch({ type: SPINNER_ON });
            delete action.payload.activeSingleCompany;
            api.user.createUser(action.payload)
                .then((res) => {
                const defaultRedirect = `${baseByData.hubUrl}buy`;
                const redirectURL = localStorage.getItem('brixelRedirectUrl');
                localStorage.removeItem('brixelRedirectUrl');
                localStorage.removeItem('brixelLoginChannel');
                setCookie('brixelToken', res.data.token);
                const alertProps = {
                    label: 'You are registered now',
                    type: 'done',
                    state: true,
                };
                store.dispatch({ type: SET_SCREEN_NOTIFICATION, payload: alertProps });
                window.location.href = redirectURL || defaultRedirect;
            })
                .catch((error) => {
                let errorMsg = 'Something went wrong while creating your account.';
                if (error.meta?.status === 409) {
                    errorMsg = 'Something went wrong. You might use a different email address.';
                }
                else if (error.meta?.status === 400) {
                    errorMsg = 'Please use a valid e-mail address';
                }
                const alertProps = {
                    state: true,
                    label: errorMsg,
                    type: 'alert',
                };
                store.dispatch({ type: SET_FORM_ERROR, payload: alertProps });
                store.dispatch({ type: SET_SCREEN_NOTIFICATION, payload: alertProps });
            })
                .finally(() => store.dispatch({ type: SPINNER_OFF }));
            break;
        }
        case GET_USER: {
            next(action);
            const { smallLoader } = action.payload;
            enableSpinner(store);
            api.user.getUser(action.payload)
                .then((response) => store.dispatch({ type: SET_USER, payload: response.data }))
                .catch((error) => {
                // eslint-disable-next-line no-console
                console.log(error);
                store.dispatch({
                    type: SET_SCREEN_NOTIFICATION,
                    payload: { label: 'Unknown error', type: 'alert', state: true },
                });
            })
                .finally(() => disableSpinner(store, smallLoader));
            break;
        }
        case UPDATE_USER: {
            next(action);
            const { smallLoader } = action.payload;
            const userID = store.getState().user.loggedUser.id;
            const { data } = action.payload;
            enableSpinner(store, smallLoader);
            api.user.updateUser(userID, data)
                .then((response) => {
                store.dispatch({
                    type: SET_SCREEN_NOTIFICATION,
                    payload: { label: 'Your changes were saved', type: 'done', state: true },
                });
                store.dispatch({ type: SET_USER, payload: response.data });
            })
                .catch((error) => {
                // eslint-disable-next-line no-console
                console.log(error);
                store.dispatch({
                    type: SET_SCREEN_NOTIFICATION,
                    payload: { label: 'Error updating the user', type: 'alert', state: true },
                });
            })
                .finally(() => disableSpinner(store, smallLoader));
            break;
        }
        default:
            next(action);
    }
};
export default checkUser;
